<template>
  <div class="def-product-status">
    <slot v-if="isAvailable(result)" name="isAvailable" />
    <slot v-else-if="onOrder(result)" name="onOrder" />
    <slot v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DefProductStatus',
  props: ['result'],
  computed: {
    ...mapGetters({
      isAvailable: 'product/isAvailable',
      onOrder: 'product/onOrder',
    }),
  },
};
</script>

<style lang="scss" scoped>
.def-product-status {
  :deep {
    .available {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 600;
      line-height: 125%;
      text-transform: uppercase;
      color: var(--color-green);
      &:before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: currentColor;
        margin-right: 8px;
      }
    }
    .notAvailable {
      display: flex;
      align-items: center;
      color: var(--color-dark-grey);
      font-size: 14px;
      font-weight: 600;
      line-height: 125%;
      text-transform: uppercase;
      &:before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: currentColor;
        margin-right: 8px;
      }
    }
  }
}
</style>
